module.exports = __webpack_public_path__ + "img/step10_a_stand_power_rotate_stand_lock_wheels.f6f332f3.png";